import { useSelector } from 'react-redux';

import { MAINTENANCE_MODE } from 'constants/index';
import { useFeatureFlags } from 'hooks/useFeatureFlags/useFeatureFlags';
import { getRecipientId } from 'selectors';

function useMaintenanceMode() {
  const isFeatureEnabled = useFeatureFlags(MAINTENANCE_MODE);
  const recipientId = useSelector(getRecipientId);

  return isFeatureEnabled && recipientId !== undefined && recipientId !== 'PTU';
}

export { useMaintenanceMode };
